export default __webpack_public_path__ + "static/media/radioCheck.8fd648f4.svg";